import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function AboutPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  const testimonials = [
    {
      name: "张先生",
      location: "北京",
      text: "白云视频真的是良心平台！画质清晰流畅，最关键是完全免费。我已经推荐给身边所有朋友了。",
      rating: 5,
    },
    {
      name: "李女士",
      location: "上海",
      text: "之前一直在找免费的看电影平台，终于找到了白云视频。片源很丰富，更新也快，好评！",
      rating: 5,
    },
    {
      name: "王同学",
      location: "广州",
      text: "大学生党省钱神器！不用开会员就能看高清电视剧，追《狂飙》的时候全靠白云视频了。",
      rating: 4,
    },
    {
      name: "赵先生",
      location: "深圳",
      text: "界面简洁无广告，播放体验比很多付费平台还好。希望能一直保持下去！",
      rating: 5,
    },
    {
      name: "刘阿姨",
      location: "成都",
      text: "退休后喜欢在家追剧，儿子给我推荐的白云视频。操作简单，剧也多，每天必看的平台。",
      rating: 5,
    },
    {
      name: "陈先生",
      location: "杭州",
      text: "作为一个影视爱好者，白云视频的内容库真的让我惊喜。找片方便，播放流畅，强烈推荐！",
      rating: 4,
    },
  ];

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20">
        <div className="max-w-[1400px] mx-auto px-4 md:px-6">
          <Breadcrumb
            items={[
              { label: "首页", href: "/" },
              { label: "关于我们" },
            ]}
          />

          {/* Brand Introduction */}
          <section className="py-10 md:py-14">
            <div className="max-w-4xl mx-auto">
              <h1 className="text-3xl md:text-4xl font-bold text-center" style={{ fontFamily: "var(--font-heading)", color: "oklch(var(--foreground-900))" }}>
                关于白云视频
              </h1>
              <p className="text-center text-foreground-500 mt-4 max-w-2xl mx-auto">
                白云视频是一个致力于为用户提供免费高清在线影视观看体验的平台。
              </p>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-10">
                <div className="bg-white border border-neutral-100 rounded-xl p-6 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-primary-100">
                    <i className="ri-vidicon-line text-2xl" style={{ color: "oklch(var(--primary-500))" }}></i>
                  </div>
                  <h3 className="text-base font-semibold mt-4" style={{ color: "oklch(var(--foreground-900))" }}>海量资源</h3>
                  <p className="text-sm text-foreground-500 mt-2">5000+高清影片，涵盖电影、电视剧、综艺、动漫等多种类型。</p>
                </div>
                <div className="bg-white border border-neutral-100 rounded-xl p-6 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-accent-100">
                    <i className="ri-shield-check-line text-2xl" style={{ color: "oklch(var(--accent-500))" }}></i>
                  </div>
                  <h3 className="text-base font-semibold mt-4" style={{ color: "oklch(var(--foreground-900))" }}>完全免费</h3>
                  <p className="text-sm text-foreground-500 mt-2">无需会员、无需付费，所有内容免费观看，让好内容触手可及。</p>
                </div>
                <div className="bg-white border border-neutral-100 rounded-xl p-6 text-center">
                  <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-2xl bg-secondary-100">
                    <i className="ri-speed-up-line text-2xl" style={{ color: "oklch(var(--secondary-500))" }}></i>
                  </div>
                  <h3 className="text-base font-semibold mt-4" style={{ color: "oklch(var(--foreground-900))" }}>高清流畅</h3>
                  <p className="text-sm text-foreground-500 mt-2">先进CDN加速技术，高清画质播放不卡顿，观影体验极佳。</p>
                </div>
              </div>
            </div>
          </section>

          {/* Brand Story */}
          <section className="py-10 md:py-14 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
                <div>
                  <h2 className="text-2xl md:text-3xl font-bold" style={{ fontFamily: "var(--font-heading)", color: "oklch(var(--foreground-900))" }}>
                    品牌故事
                  </h2>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-4">
                    白云视频诞生于对优质影视内容的热爱。我们相信，每个人都应该能够自由地享受精彩的影视作品，而不必为高昂的会员费用所困扰。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                    自成立以来，白云视频始终坚持"免费、高清、流畅"的核心理念，聚合海量电影、电视剧、综艺、动漫等内容资源，以流畅的播放体验和简洁的界面设计，让每一位用户都能轻松享受观影乐趣。
                  </p>
                  <p className="text-sm text-foreground-600 leading-relaxed mt-3">
                    我们与西瓜视频、糖豆视频、小蓝视频等优质平台保持紧密合作，不断丰富内容库，为用户提供更加多元化的观影选择。未来，白云视频将继续努力，成为用户最信赖的免费影视平台。
                  </p>
                </div>
                <div className="rounded-xl overflow-hidden aspect-[4/3]">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20home%20entertainment%20setup%20with%20large%20TV%20displaying%20colorful%20film%20content%2C%20cozy%20living%20room%20atmosphere%2C%20warm%20ambient%20golden%20lighting%2C%20comfortable%20sofa%20with%20throw%20pillows%2C%20relaxing%20movie%20night%20vibe%2C%20high-end%20interior%20design&width=800&height=600&seq=about-brand-story&orientation=landscape"
                    alt="白云视频品牌形象"
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="py-10 md:py-14">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-center" style={{ fontFamily: "var(--font-heading)", color: "oklch(var(--foreground-900))" }}>
                用户口碑
              </h2>
              <p className="text-center text-foreground-500 text-sm mt-3">听听用户们怎么说</p>

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-8">
                {testimonials.map((t, idx) => (
                  <div key={idx} className="bg-white border border-neutral-100 rounded-xl p-5">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: 5 }, (_, i) => (
                        <i
                          key={i}
                          className={`text-sm ${i < t.rating ? "ri-star-fill" : "ri-star-line"}`}
                          style={{ color: i < t.rating ? "oklch(var(--accent-500))" : "oklch(var(--foreground-300))" }}
                        ></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed">{t.text}</p>
                    <div className="flex items-center gap-2 mt-4 pt-3 border-t border-neutral-50">
                      <div className="w-8 h-8 rounded-full bg-secondary-100 flex items-center justify-center">
                        <span className="text-xs font-semibold" style={{ color: "oklch(var(--secondary-600))" }}>{t.name[0]}</span>
                      </div>
                      <div>
                        <p className="text-xs font-medium text-foreground-800">{t.name}</p>
                        <p className="text-xs text-foreground-400">{t.location}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Contact */}
          <section className="py-10 md:py-14 bg-background-100 -mx-4 md:-mx-6 px-4 md:px-6">
            <div className="max-w-4xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-center" style={{ fontFamily: "var(--font-heading)", color: "oklch(var(--foreground-900))" }}>
                联系我们
              </h2>
              <p className="text-center text-foreground-500 text-sm mt-3">如有任何问题或建议，欢迎联系我们</p>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-8">
                <div className="bg-white border border-neutral-100 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-mail-line text-lg" style={{ color: "oklch(var(--primary-500))" }}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold" style={{ color: "oklch(var(--foreground-900))" }}>电子邮箱</h3>
                      <p className="text-sm text-foreground-500 mt-1">contact@baiyunvideo.com</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-neutral-100 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 flex-shrink-0">
                      <i className="ri-customer-service-2-line text-lg" style={{ color: "oklch(var(--accent-500))" }}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold" style={{ color: "oklch(var(--foreground-900))" }}>在线客服</h3>
                      <p className="text-sm text-foreground-500 mt-1">工作日 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-neutral-100 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 flex-shrink-0">
                      <i className="ri-wechat-line text-lg" style={{ color: "oklch(var(--secondary-500))" }}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold" style={{ color: "oklch(var(--foreground-900))" }}>微信公众号</h3>
                      <p className="text-sm text-foreground-500 mt-1">搜索关注「白云视频」</p>
                    </div>
                  </div>
                </div>
                <div className="bg-white border border-neutral-100 rounded-xl p-6">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg" style={{ color: "oklch(var(--primary-500))" }}></i>
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold" style={{ color: "oklch(var(--foreground-900))" }}>公司地址</h3>
                      <p className="text-sm text-foreground-500 mt-1">北京市朝阳区光华路88号</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ on About page */}
          <section className="py-10 md:py-14">
            <div className="max-w-3xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold text-center mb-8" style={{ fontFamily: "var(--font-heading)", color: "oklch(var(--foreground-900))" }}>
                常见问题
              </h2>
              <div className="space-y-3">
                {[
                  { q: "如何开始使用白云视频？", a: "直接在浏览器中打开白云视频官网即可开始观看，无需注册、无需下载、无需付费。" },
                  { q: "需要安装APP吗？", a: "不需要。白云视频是网页版视频平台，直接在浏览器中访问即可，兼容电脑、平板和手机。" },
                  { q: "白云视频有广告吗？", a: "白云视频致力于提供清爽的观影体验，大幅减少广告干扰，让您专注于内容本身。" },
                ].map((faq, idx) => (
                  <details key={idx} className="group bg-white border border-neutral-100 rounded-xl overflow-hidden">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-50 transition-colors">
                      <span className="text-sm font-medium text-foreground-800">{faq.q}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-500 leading-relaxed">{faq.a}</p>
                    </div>
                  </details>
                ))}
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
}